/**
 * Oferta DPS45 · Gestalt Session Ready.
 * Todo lo que tiene que ver con precio, checkout y ventana de lanzamiento
 * vive acá, para cambiarlo en un solo lugar.
 */
export const PRODUCT_NAME = 'Gestalt Session Ready'
export const PRODUCT_FULL_NAME =
  'Gestalt Session Ready: The Complete Experiment Library'

export const CHECKOUT_URL =
  'https://gestalt-session-ready.impultienda.ar/checkout'

export const PRICE = 27
/** Precio regular después del lanzamiento (A CONFIRMAR por Lucas). */
export const REGULAR_PRICE = 47

/**
 * Fin de la ventana de lanzamiento: fecha FIJA, igual para todos los
 * visitantes (no se reinicia por visita). Al vencer, la sección de urgencia
 * y el contador del cierre se ocultan solos. A CONFIRMAR por Lucas.
 */
export const LAUNCH_DEADLINE = '2026-10-28T23:59:00-03:00'
